<template>
  <div class="wrapper">
    <div class="data-wrapper">
      <div class="main">
        <div class="report">
          <div class="modal">
            <div class="message">
              <div />
              <div>
                <img 
                  class="logo"
                  src="@/assets/img/logo_icon.svg"
                >
              </div>
              <div>
                <b>Clicks</b>Control
              </div>
              <div />
            </div>
            <form @submit.prevent="authenticate()">
              <div class="auth-form-data">
                <div>
                  <input 
                    ref="email" 
                    v-model="auth.login"
                    type="email"
                    placeholder="Email"
                  >
                </div>
                <div>
                  <input 
                    ref="password"
                    v-model="auth.password"
                    type="password"
                    placeholder="Password"
                  >
                </div>
              </div>
              <div>
                <button type="submit">
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- <Loading :active="isLoading" :can-cancel="false"></Loading> -->
  </div>
</template>

<script>
import NProgress from 'nprogress'

export default {
  data () {
    return {
      auth: {
        login: '',
        password: ''
      },
    }
  },

  created () {
    this.$emit('ready')
  },
  
  methods: {
    async authenticate () {
      let credentials = this.auth
      let success = await this.login(credentials)

      if (success) {
        this.successRedirect()
      }
    },

    async login (credentials) {
      NProgress.start()
      await this.$store.dispatch('auth/login', credentials)
      .catch(() => {
        this.showMessage()
      })
      NProgress.done()

      return this.$store.getters['auth/getAuthStatus']
    },

    successRedirect () {
      const redirectTo = this.$route.query.redirectTo || { name: 'Home' }
      this.$router.push(redirectTo)
    },

    showMessage () {
      this.$message.error('Warning! Incorrect credentials! Please try again.');
    }
  },

}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Lato:400,400i,700,900&display=swap&subset=latin-ext');

.wrapper {
  display: grid;
  grid-template-areas:
          "header"
          "content"
          "footer";
  width: 100%;
  overflow-x: hidden;
}

.data-wrapper {
  display: flex;
}

.main {
  display: grid;
  grid-template-columns: auto;
  width: 100vw;
  background-image: url('../assets/img/login_background.jpeg');
  background-size: cover;
}

.report {
    background: linear-gradient(to left, rgba(0, 204, 209, 0.8), rgba(4, 12, 107, 0.8));
    max-width: 100%;
    height: 100vh;
    width: 100vw;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;

    .modal {
        width: 320px;


        & > .message {
            color: #fff;
            font-family: 'Lato';
            display: grid;
            grid-template-columns: auto 50px 160px auto;
            align-items: center;
            font-size: 25px;

            img {
                width: 100%;
            }

            b{
                font-weight: bold;
            }
        }

        & > form {
            background-color: transparent;
            display: flex;
            flex-direction: column;
            align-items: center;
            align-self: center;

            & > .auth-form-data {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                text-align: center;
                width: 100%;

                & > div {
                    margin-top: 15px;
                    width: 100%;
                    position: relative;
                    background-color: rgba(255,255,255,0.4);
                    color: #fff !important;

                    & > input::placeholder{
                        color: #fff !important;
                        font-family: 'Lato';
                        position: absolute;
                        top: 50%;
                        font-size: 16px;
                        margin-top: -10px;
                        margin-left: 14px;
                        font-style: italic;
                        opacity: 1;
                    }

                    & > input {
                        color: #fff !important;
                        animation-name: autofill;
                        animation-fill-mode: both;
                        box-sizing: border-box;
                    }

                    & > input:-webkit-autofill,
                    & > input:-webkit-autofill:hover,
                    & > input:-webkit-autofill:focus,
                    & > input:-internal-autofill-selected
                    {
                        -webkit-text-fill-color: #fff !important;
                        -webkit-animation-name: autofill;
                        -webkit-animation-fill-mode: both;
                    }

                    @-webkit-keyframes autofill {
                        to {
                            margin-left: 0;
                            border: 0;
                            background: transparent;
                            color: #fff !important;
                            -webkit-text-fill-color: #fff !important;
                            height: 50px;
                            width: 100%;
                            font-family: 'Lato', Arial, sans-serif;
                            padding-left: 14px;
                            font-size: 16px;
                        }
                    }
                }
            }

            & > div {
                margin-top: 15px;
                width: 100%;
            }

            button {
                width: 100%;
                height: 50px;
                border: 0;
                background: #2892ea;
                color: #fff;
                font-family: 'Lato';
                font-weight: bolder;
                text-transform: uppercase;
                font-size: 16px;
            }
        }

        &.sidebar-active {
            padding-left: 125px;
        }
    }
}

.clear {
  clear: both;
}

// @include mobile-only {
//   .main {
//     background-position: 43%;
//   }
// }
</style>